<script setup lang="ts">
import {
	getProductSharingUrl,
	productSharingData,
} from '@/legacy/ts/productSharing'
import useProductSharing from '@/legacy/ts/useProductSharing'
import BsButtonNormal from '@/legacy/components/ButtonNormal.vue'
import BsButtonOutline from '@/legacy/components/ButtonOutline.vue'
import { instanceProductSharing } from '@/assets/ts/apiManagement'
import injectStrict from '@/lib/inject'
import { type TypeInjectUpdateUserProfile } from '@/types/ProductSharing'

const props = defineProps({
	name: {
		type: String,
		require: true,
	},
	text: {
		type: Object,
	},
	isFollowed: {
		type: Boolean,
		require: true,
	},
	isWidthFull: {
		type: Boolean,
		default: false,
	},
})

const addMessage: (message: string) => void = injectStrict('addMessage')
const updateUserProfile: TypeInjectUpdateUserProfile =
	injectStrict<TypeInjectUpdateUserProfile>('updateUserProfile')
const { isHasPSProfile } = useProductSharing()

function followUser() {
	if (!productSharingData.isLogin) {
		window.BsHeaderVm.showPanel('login')
		return
	}
	isHasPSProfile().then(isProfileExist => {
		if (!isProfileExist) {
			window.location.href = getProductSharingUrl('private-index')
		}
		const actionName = props.isFollowed ? 'unfollow' : 'follow'
		const suffix = props.isFollowed ? 'unfollow' : 'v2/follow'
		instanceProductSharing
			.post(`/${suffix}`, { username: decodeURIComponent(props.name || '') })
			.then(res => {
				const response: {
					isFollowed: boolean
					followerCount: number
				} = {
					isFollowed: res.data.data.user.is_followed,
					followerCount: res.data.data.user.follower_count,
				}

				updateUserProfile(
					(Object.keys(response) as Array<keyof typeof response>).map(key => {
						return {
							param: key,
							val: response[key],
						}
					}),
				)
				addMessage(props.text?.msg[actionName].success)
			})
			.catch(() => {
				addMessage(props.text?.msg[actionName].fail)
			})
	})
}
</script>

<template>
	<div
		:class="[
			'bs-product-sharing-follow-button',
			{ 'bs-product-sharing-follow-button__full': isWidthFull },
		]"
	>
		<BsButtonNormal
			v-if="!isFollowed"
			:action="followUser"
			:text="text?.button.follow"
		></BsButtonNormal>
		<BsButtonOutline
			v-if="isFollowed"
			:action="followUser"
			:text="text?.button.unFollow"
		></BsButtonOutline>
	</div>
</template>
